import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const templateApiService = createApi({
  reducerPath: "templateApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createTemplate: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `template/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getAllTemplates: builder.query({
      query: (params) => {
        const query = queryParams(params);
        return {
          url: `template${query}`,
          method: "GET",
        };
      },
    }),
    getTemplateById: builder.query({
      query: ({ id, params }) => {
        let query = queryParams(params);
        return {
          url: `template/${id}${query}`,
          method: "GET",
        };
      },
    }),
    updateTemplate: builder.mutation({
      query: ({ id, payload, params }) => {
        let query = queryParams(params);
        return {
          url: `template/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useCreateTemplateMutation,
  useGetAllTemplatesQuery,
  useGetTemplateByIdQuery,
  useUpdateTemplateMutation,
} = templateApiService;
